import pageTag from './pagetags';
import eventTag from './pageevents';
import _ from 'lodash';

var ENV = 'dev';
const PROFILE = 'global-gbm-dart';

const MAX_RETRIES = 6;
let scriptsLoading = false;
let scriptsLoaded = false;
let scriptLoadError = false;

// track a single page view
export async function trackView(pageName, locale, args) {
    if (scriptLoadError || isTrackingDisabled()) {
        return;
    }

    if (_.isEmpty(pageName)) {
        return;
    }

    for (let i = 0; i < MAX_RETRIES; i++) {
        if (scriptsLoaded || scriptLoadError) {
            break;
        } else if (scriptsLoading) {
            await sleep(i * i);
        } else {
            // lazy load scripts
            await loadTrackingScripts();
            break;
        }
    }

    // clone so we don't modify the source
    let page = _.clone(pageTag[pageName]);

    if (_.isEmpty(page)) {
        return;
    }

    if (!_.isUndefined(locale)) {
        page.page_language = locale;
    }
    if (args != null) {
        // merge in params
        for (let i = 0; i < args.length; i++) {
            const pattern = new RegExp(`\\{${i}\\}`, 'g');
            _.forOwn(page, function(value, key) {
                page[key] = value.replace(pattern, args[i]);
            });
        }
    }

    try {
        TMS && TMS.trackView(page);
    } catch (error) {
        console.warn(error);
    }
}

// track a single user event
export async function trackEvent(pageName, eventName, args) {
    if (isTrackingDisabled() || scriptLoadError) {
        return;
    }

    if (_.isEmpty(pageName) || _.isEmpty(eventName)) {
        return;
    }

    for (let i = 0; i < MAX_RETRIES; i++) {
        if (scriptsLoaded || scriptLoadError) {
            break;
        } else if (scriptsLoading) {
            await sleep(i * i);
        } else {
            // lazy load scripts
            await loadTrackingScripts();
            break;
        }
    }

    // clone so we don't modify the source
    let event = _.clone(eventTag[pageName][eventName]);

    if (_.isUndefined(event)) {
        return;
    }

    if (args != null) {
        // merge in params
        for (let i = 0; i < args.length; i++) {
            const pattern = new RegExp(`\\{${i}\\}`, 'g');
            event.event_content = event.event_content.replace(pattern, args[i]);
        }
    }

    try {
        TMS && TMS.trackEvent(event);
    } catch (error) {
        console.warn(error);
    }
}

// load all script files required for user tracking
async function loadTrackingScripts() {
    if (isTrackingDisabled() || scriptsLoaded) {
        return;
    }

    scriptsLoading = true;

    try {
        await loadScript(
            `//tags.tiqcdn.com/utag/hsbc/${PROFILE}/${ENV}/utag.sync.js`
        );
        await loadScript(`//tags.tiqcdn.com/utag/hsbc/${PROFILE}/${ENV}/utag.js`);
    } catch (error) {
        scriptLoadError = true;
        console.warn(error);
    } finally {
        scriptsLoading = false;
    }

    scriptsLoaded = true;
}

// dynamically load a single script
async function loadScript(url) {
    return new Promise(function(resolve, reject) {
        let script = document.createElement('script');
        script.src = url;
        script.type = 'text/javascript';
        script.async = true;

        script.onload = () => {
            resolve(url);
        };

        script.onerror = () => {
            reject(url);
        };

        // insert the script tag before the first script tag in the document
        let firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.insertBefore(script, firstScript);
    });
}

// respect the user
const isTrackingDisabled = function() {
    if (ENV === 'localDev') {
        return true;
    }

    if (navigator === undefined || navigator.doNotTrack === undefined) {
        return false;
    }

    return navigator.doNotTrack === '1';
};

function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

// let env = _.trim(document.getElementById('env').innerHTML);
// ENV = env ? env : ENV;



// WEBPACK FOOTER //
// ./shared/userTracking/analytics.js